import React from "react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-stone-200/70 bg-sand-50 mt-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12 grid md:grid-cols-3 gap-10">
        <div>
          <div className="font-serif text-xl text-stone-900">Atmia Education</div>
          <p className="text-sm text-stone-600 mt-2 leading-relaxed">
            Guiding students towards their dream of becoming doctors — counselling, admissions, visa,
            accommodation & local support for MBBS in Georgia.
          </p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-saffron-600 font-medium mb-3">University Partner</div>
          <div className="text-stone-800 font-medium">SEU – Georgian National University</div>
          <div className="text-sm text-stone-600 mt-1">Tbilisi, Georgia</div>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-saffron-600 font-medium mb-3">Care & Support</div>
          <div className="text-sm text-stone-600">Atmia Saffron Kingdom — Indian/Gujarati meals</div>
          <div className="text-sm text-stone-600 mt-1">Local team in Georgia, 24/7 assistance</div>
        </div>
      </div>
      <div className="border-t border-stone-200/60">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-5 text-xs text-stone-500 flex flex-wrap items-center justify-between gap-2">
          <span>© {new Date().getFullYear()} Atmia Education. All rights reserved.</span>
          <span className="italic font-serif">Guiding Students Towards Their Dream of Becoming Doctors</span>
        </div>
      </div>
    </footer>
  );
}
